import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    ActionService,
    ChatContext,
    InvitationService,
    LoggingService,
    NotificationService,
    OptionsService,
    VisitService
} from './services';
import { CloseReason } from './models/close-reason.model';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Invitation, Options } from './models';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

    invitationResourceStrings: Invitation = {};
    CloseReason: typeof CloseReason = CloseReason;
    faTimes = faTimes;
    error: string;
    proactiveErrorSubscription: Subscription;
    

    constructor(
        private optionsService: OptionsService,
        private visitService: VisitService,
        private invitationService: InvitationService,
        private notificationService: NotificationService,
        private loggingService: LoggingService,
        private actionService: ActionService
       
    ) {
        this.notificationService.location$.subscribe(context => this.onLocationChanged(context));
        this.optionsService.options$.subscribe(options => this.onOptionsChanged(options));

        this.proactiveErrorSubscription = this.notificationService.proactiveChatError$.subscribe(errorMessage => {
            this.error = errorMessage;

            //Disable logging for error view
            this.loggingService.disableLogging = true;
            this.invitationService.showProactivErrorView();
        });
    }

    ngOnInit() {
        console.info('Init: [ProactiveChat] Initializing.');
        // Ask the snippet's script to provide us with the initial url of the customer's page.
        // this.notificationService.requestLocation();
    }

    onLocationChanged(context: ChatContext): void {
        console.log(`Init: [ProactiveChat] location has been changed to ${context.location.href}`);
        this.error = null;

        // Cancel all action as we can have a different skill for the new location.
        this.actionService.cancelAll();

        // Log the visit.
        this.visitService.logVisit(context.location.href);

        // Update logging information for reporting
        this.loggingService.updateChatContext(context);

        // Update chat context to option services
        this.optionsService.updateChatContext(context);
    }

    onOptionsChanged(options: Options) {
        console.log(`Init: [ProactiveChat] fetched options for ${options.Location} location`);

        // init actions
        this.actionService.init(options);
        this.notificationService.sendApplicationStarted(options.SessionId);
        this.invitationResourceStrings = options.Invitation;
        this.actionService.start();
    }

    hideInvitation(reason: CloseReason) {
        this.invitationService.hideInvitation(reason);
        this.actionService.cancelCloseInvitation();
        this.error = null;
        this.loggingService.disableLogging = false;
    }

    acceptInvitation() {
        this.invitationService.acceptInvitation();
        this.actionService.cancelCloseInvitation();
    }

    ngOnDestroy() {
        this.proactiveErrorSubscription.unsubscribe();
        this.actionService.cancelAll();
    }
}

